module.exports = __webpack_public_path__ + "static/media/swords-laser.946daabb.svg";